import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsCategory } from "../../@hooks"


export default function UserSettingsCategoryTabButton() {

    const { handleSetCategoryFormData } = useUserSettingsCategory()

    return <AppToolbarCreateButton
        label="Define Category Color"
        onClick={handleSetCategoryFormData}
    />
}